<template>
  <div class="roster-sync-modal" data-cy="versions-modal" role="dialog" aria-modal="true" aria-labelledby="message-versions-title">
    <div class="roster-sync-modal__backdrop" @click="close"></div>

    <div class="roster-sync-modal__shell">
      <header class="roster-sync-modal__header">
        <div>
          <h2 id="message-versions-title" class="roster-sync-modal__title">Edit history</h2>
          <p class="roster-sync-modal__subtitle">Most recent version first.</p>
        </div>
        <button type="button"
                class="harbor-chat__icon-btn"
                aria-label="Close"
                @click="close">
          <i class="fa-solid fa-xmark" aria-hidden="true"></i>
        </button>
      </header>

      <div class="roster-sync-modal__body">
        <div v-if="loading" class="text-center p-m">
          <spinner></spinner>
        </div>
        <template v-else>
          <div class="msg-version" data-cy="version-current">
            <div class="msg-version__meta">
              <span class="msg-version__badge">Current</span>
              <span class="msg-version__author">{{ editorName(message.edited_by) || message.author.display_name }}</span>
              <span class="msg-version__timestamp">{{ formatTime(message.edited_at || message.updated_at) }}</span>
            </div>
            <div class="msg-version__body trix-content" v-html="currentContent"></div>
          </div>

          <div v-for="(version, idx) in versions"
               :key="`version-${version.id}`"
               class="msg-version msg-version--previous"
               data-cy="version-previous">
            <div class="msg-version__meta">
              <span class="msg-version__badge msg-version__badge--previous">v{{ versionNumber(idx) }}</span>
              <span class="msg-version__author">{{ editorName(version.edited_by) }}</span>
              <span class="msg-version__timestamp">{{ formatTime(version.created_at) }}</span>
            </div>
            <div class="msg-version__body trix-content" v-html="versionContent(version)"></div>
          </div>

          <p v-if="error" class="text-danger m-t-sm m-b-none">{{ errorMessage }}</p>
        </template>
      </div>

      <footer class="roster-sync-modal__footer">
        <button type="button" class="btn btn-default" @click="close">Close</button>
      </footer>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import Spinner from './spinner.vue';
import { errorableMix } from './mixins/errorable_mix';
import { urlHelperMixin } from './mixins/url_helper_mix';

export default {
  name: 'message-versions-modal',
  components: { Spinner },
  mixins: [errorableMix, urlHelperMixin],
  props: {
    message: { type: Object, required: true },
    messageGroupId: { type: Number, required: true },
  },
  data() {
    return {
      loading: false,
      versions: [],
    };
  },
  computed: {
    currentContent() {
      if (this.message.rich_content && this.message.rich_content.length > 0) {
        return this.message.rich_content;
      }
      if (!this.message.content) return '';
      return this.plainContentHtml(this.message.content);
    },
  },
  created() {
    this.fetchVersions();
    document.body.classList.add('composer-overlay-open');
    document.addEventListener('keydown', this.handleKeydown);
  },
  destroyed() {
    document.body.classList.remove('composer-overlay-open');
    document.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    fetchVersions() {
      const vm = this;
      vm.loading = true;
      const url = `${vm.$apiService.messageVersionsUrl(vm.messageGroupId, vm.message.id)}?per_page=100`;
      axios.get(url)
        .then((response) => {
          vm.loading = false;
          vm.versions = response.data.message_versions || [];
        })
        .catch((error) => {
          vm.loading = false;
          vm.errorMessage = vm.parseErrorResponse(error);
          vm.error = true;
        });
    },
    versionContent(version) {
      if (version.rich_content && version.rich_content.length > 0) {
        return version.rich_content;
      }
      if (!version.content) return '';
      return this.plainContentHtml(version.content);
    },
    versionNumber(idx) {
      // versions are recent-first; number them so the oldest is v1
      return this.versions.length - idx;
    },
    editorName(editor) {
      return editor?.display_name || '';
    },
    formatTime(ts) {
      if (!ts) return '';
      return moment(ts).format('MMM D, YYYY [at] h:mma');
    },
    handleKeydown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        this.close();
      }
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>
